import React from "react";
import PropTypes from "prop-types";

import Helmet from "../../components/Helmet";
import Loading from "../../components/Loading";
import EventBanner from "../../components/event/EventBanner";
import { useEventParticipationSubmission } from "../../context/EventParticipationSubmissionManager";
import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { getEventParticipationSubmissionState } from "../../utilities/eventParticipationSubmissionState";

function EventParticipationSubmissionPage({ event }) {
    const {
        event: contextEvent,
        errors,
        hasPendingSubmission,
        hasAcceptedSubmission,
    } = useEventParticipationSubmission();
    const currentEvent = contextEvent ?? event;
    const {
        open: participationSubmissionsOpen,
    } = getEventParticipationSubmissionState(currentEvent);

    if (!currentEvent) {
        return (
            <div className="background-black">
                <div className="d-flex flex-column justify-content-center w-100">
                    <Loading />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <Helmet
                title={`Inschrijven voor ${currentEvent.name}`}
            />
            <div className="background-black">
                <div className="d-flex flex-column justify-content-center w-100">
                    <EventBanner
                        event={currentEvent}
                        backLink={`/event/${currentEvent.id}`}
                        backLinkText="Terug naar evenement"
                    />
                    <div className="container">
                        {errors.submit && (
                            <div className="alert alert-warning">
                                {errors.submit}
                            </div>
                        )}
                        {hasPendingSubmission && !hasAcceptedSubmission && (
                            <div className="alert alert-warning">
                                U heeft al een lopende inschrijving voor dit evenement. De inschrijving is in behandeling bij de organisatie van het evenement.
                            </div>
                        )}
                        {hasAcceptedSubmission && (
                            <div className="alert alert-success">
                                Uw inschrijving voor dit evenement is geaccepteerd.
                            </div>
                        )}
                        {!participationSubmissionsOpen && (
                            <div className="alert alert-secondary">
                                Inschrijvingen voor dit evenement zijn momenteel gesloten.
                            </div>
                        )}
                        <h1 className="text-white">{currentEvent.name}</h1>
                        {currentEvent.eventParticipationSubmissionIntroText ? (
                            <ReactMarkdown className="text-white">{currentEvent.eventParticipationSubmissionIntroText}</ReactMarkdown>
                        ) : (
                            <p className="text-white">Start de inschrijving voor {currentEvent.name}</p>
                        )}
                        {!hasPendingSubmission && !hasAcceptedSubmission && participationSubmissionsOpen && (
                            <Link
                                to={`/event/${currentEvent.id}/participation-submission/naw`}
                                className="btn btn-primary" style={{ backgroundColor: (currentEvent?.tintColor ?? "#fae33d"), borderColor: (currentEvent?.tintColor ?? undefined), color: (currentEvent?.buttonTextColor ?? "black") }}
                            >
                                    Start inschrijving
                            </Link>
                        )}
                        {!hasPendingSubmission && !hasAcceptedSubmission && !participationSubmissionsOpen && (
                            <button
                                type="button"
                                className="btn btn-secondary"
                                disabled
                            >
                                Inschrijvingen gesloten
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

EventParticipationSubmissionPage.propTypes = {
    event: PropTypes.shape({
        name: PropTypes.string.isRequired,
        eventParticipationSubmissionIntroText: PropTypes.string,
        id: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]).isRequired,
        tintColor: PropTypes.string,
        buttonTextColor: PropTypes.string,
    }),
};

export default EventParticipationSubmissionPage;
